export default __webpack_public_path__ + "static/media/Brigand's Gloves of a Hundred Eyes.a21b544a.jpg";